__turbopack_context__.v({
  "list": "StepList-module-scss-module__2HRPMW__list",
  "list__iconContainer": "StepList-module-scss-module__2HRPMW__list__iconContainer",
  "list__item": "StepList-module-scss-module__2HRPMW__list__item",
  "list__itemSubtitle": "StepList-module-scss-module__2HRPMW__list__itemSubtitle",
  "list__itemTitle": "StepList-module-scss-module__2HRPMW__list__itemTitle",
  "list__textWrapper": "StepList-module-scss-module__2HRPMW__list__textWrapper",
});
